import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { HeroSmallComponent, IDynamicElement } from '@sirius/common';
import { CountdownComponent } from '../countdown/countdown.component';
import { IHeroSmallEventPage } from 'shared/models';

@Component({
    imports: [HeroSmallComponent, CountdownComponent],
    selector: 'ur-event-page-hero-header',
    templateUrl: './event-page-hero-header.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./event-page-hero-header.component.scss'],
})
export class EventPageHeroHeaderComponent implements IDynamicElement {
    @Input()
    config?: IHeroSmallEventPage;
}
